import { TEDFormatFloat } from './TEDFormatFloat';

class TEDFormatIntAsFloat extends TEDFormatFloat {}

export { TEDFormatIntAsFloat };
